// extracted by mini-css-extract-plugin
export default {"card":"GameOnboardingInfoCard_card__o+9cs"};